import React from "react"
import {User} from "@irati/types"
import Expander from "@irati/ui/src/Expander"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {Body, Label} from "@irati/ui/src/Typography"
import ArrowDropdown from "@irati/ui/images/arrow_dropdown.svg"
import {FormattedMessage} from "@irati/utils/lang"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {IconButton} from "@irati/ui/src/Button"
import {RecipientContainer, ExpandList, ArrowUp, RecipientsListContainer} from "./styled"

const MAX_RECIPIENTS_SHOWN = 3
interface Props {
  recipients: User[]
  onDeleteItem?: (uuid: string) => void
}
const UserItem = (props: {user: User; onDeleteItem?: () => void}) => {
  const {user, onDeleteItem} = props
  const onDeleteClick = (e) => {
    e.stopPropagation()
    onDeleteItem?.(user.uuid)
  }
  return (
    <RecipientContainer key={user.uuid}>
      <ProfilePicture user={user} marginRight small />
      <Label>{firstnameLastname(user)}</Label>
      {onDeleteItem && <IconButton onClick={onDeleteClick} icon={IconTypes.cross} size={12} />}
    </RecipientContainer>
  )
}
const RecipientsList = (props: Props) => {
  const {recipients, onDeleteItem} = props
  const AllRecipientsList = recipients.map((user) => <UserItem user={user} key={user.uuid} onDeleteItem={onDeleteItem} />)

  if (recipients.length > MAX_RECIPIENTS_SHOWN) {
    const minimizedRecipients = recipients.slice(0, MAX_RECIPIENTS_SHOWN)
    return (
      <Expander
        showArrow={false}
        showText={
          <div>
            <RecipientsListContainer>
              {minimizedRecipients.map((user) => (
                <UserItem user={user} onDeleteItem={onDeleteItem} />
              ))}
            </RecipientsListContainer>
            {recipients.length > MAX_RECIPIENTS_SHOWN && (
              <ExpandList>
                <Body>
                  <FormattedMessage
                    id="platform.recipients.list.extraRecipients"
                    values={{count: recipients.length - MAX_RECIPIENTS_SHOWN}}
                  />
                </Body>
                <img src={ArrowDropdown} alt="dropdown arrow" />
              </ExpandList>
            )}
          </div>
        }
        hideText={
          <>
            <RecipientsListContainer>{AllRecipientsList}</RecipientsListContainer>
            <ExpandList>
              <Body>
                <FormattedMessage id="platform.recipients.list.hide" />
              </Body>
              <ArrowUp src={ArrowDropdown} />
            </ExpandList>
          </>
        }
      />
    )
  }
  return <RecipientsListContainer>{AllRecipientsList}</RecipientsListContainer>
}

export default RecipientsList
